import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export type UsePetitionAiGuidanceExperiment = ModelHookResult<{
	isEnabled: boolean;
}>;

export function usePetitionAiGuidanceExperiment(): UsePetitionAiGuidanceExperiment {
	const {
		data: {
			viewer: {
				experiments: {
					starterExperienceDashboardPetitionAiGuidanceExperiment: { variation },
				},
			},
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			isEnabled: variation === 'enabled',
		},
	};
}
